import React, { Component } from 'react';
import { useFormikContext, useField, Field, ErrorMessage } from 'formik';


export const SimpleField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    let label = props.label || (props.name.charAt(0).toUpperCase() + props.name.slice(1));
    return (
    <div className="form-group">
        <label htmlFor={props.name}>{label}</label>
            <Field id={props.name} className="form-control" type={props.type || "text"} name={props.name} { ...props } />
        <ErrorMessage name={props.name} component="div" />
    </div>)
}

export default SimpleField;
